import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "swimlanes-wrap" }
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = { class: "child-lists flex flex-col" }

import useSwimlanes from '../../boards/composables/useSwimlanes';
import BoardListHeader from '@/components/widgets/BoardListHeader.vue';
import SwimlanesList from '@/components/widgets/SwimlanesList.vue';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SwimlanesView',
  props: {
  mainListIds: {
    type: Array,
    required: true,
  },
  maxDisplayedLists: {
    type: Number,
    default: 4,
  },
  position: {
    type: Number,
    required: false,
    default: 0,
  },
  containerWidth: {
    type: Number,
    required: false,
    default: 0,
  },
  visibleListIds: {
    type: Function,
    required: false,
    default: () => [],
  },
},
  setup(__props) {

const { boardGroupBy, showStatusIconPickerMainGroup, subGroupByObject, hideEmptyGroups } =
  useSwimlanes();

const props = __props;

const getMainListCards = (listId: unknown) => {
  const safeListId = String(listId);
  const listCards: string[] = [];
  if (subGroupByObject.value && subGroupByObject.value.order) {
    for (const subListId of subGroupByObject.value.order) {
      listCards.push(...(subGroupByObject.value[safeListId]?.[subListId]?.cardIds || []));
    }
  }
  return listCards;
};

// Check if a main list is empty (has no cards)
const isMainListEmpty = (mainListId: unknown) => {
  if (!hideEmptyGroups.value) {
    return false;
  }

  const cards = getMainListCards(mainListId);
  return cards.length === 0;
};

// Computed property to get the list of empty main list IDs
const emptyMainListIds = computed(() => {
  if (!hideEmptyGroups.value) {
    return [];
  }

  return (props.mainListIds as Array<unknown>)
    .filter((mainListId) => {
      return isMainListEmpty(mainListId);
    })
    .map((id) => String(id));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.mainListIds, (mainList, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["flex flex-row", {
          'empty-group': isMainListEmpty(mainList),
        }])
        }, [
          _createVNode(BoardListHeader, {
            "list-id": String(mainList),
            "header-footer-style": {},
            expandable: false,
            "show-status-icon-picker": _unref(showStatusIconPickerMainGroup),
            "disable-status-icon-picker": true,
            "group-by": _unref(boardGroupBy),
            "list-cards": getMainListCards(mainList),
            visible: true,
            "is-cards-layout-timeline": false,
            "is-epic-board": false,
            "is-main-group": true
          }, null, 8, ["list-id", "show-status-icon-picker", "group-by", "list-cards"])
        ], 2))
      }), 128))
    ]),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subGroupByObject).order || [], (subGroupList) => {
        return (_openBlock(), _createElementBlock("div", {
          key: subGroupList,
          class: "flex flex-col"
        }, [
          _createVNode(SwimlanesList, {
            "list-id": subGroupList,
            "main-list-ids": props.mainListIds,
            "max-displayed-lists": props.maxDisplayedLists,
            position: props.position,
            "container-width": props.containerWidth,
            "empty-main-lists": emptyMainListIds.value
          }, null, 8, ["list-id", "main-list-ids", "max-displayed-lists", "position", "container-width", "empty-main-lists"])
        ]))
      }), 128))
    ])
  ]))
}
}

})